import React, { useState } from "react";

import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import SecondaryButton from "shared/components/inputs/button/SecondaryButton";
import Table from "shared/components/data-display/tables/Table";
import TableFilters from "shared/components/data-display/tables/TableFilters";
import VStack from "shared/components/layout/stack/VStack";
import { getCellWidthInPercent } from "features/admin/clients/ClientsTable";
import useRegions from "features/admin/regions/useRegions";

const columns = [
    {
        headCellProps: {
            text: "ID",
            width: "6.4%",
        },

        getBodyCellProps: (cell) => ({
            text: cell.value,
            tooltip: `Legacy ID: ${cell.row.original.LegacyId}`,
        }),
        filter: (rows, _columnIds, filterValue) => {
            return rows?.filter((row) => {
                return (
                    (filterValue === "active" && row.values.Active === true) ||
                    (filterValue === "inactive" && row.values.Active === false)
                );
            });
        },
        accessor: "RegionId",
    },
    {
        headCellProps: {
            text: "Name",
            width: "48%",
        },
        getBodyCellProps: (cell) => ({
            text: cell.value ?? "-",
        }),
        accessor: "Name",
    },
    {
        headCellProps: {
            text: "Short Name",
            width: "48%",
        },
        getBodyCellProps: (cell) => ({
            text: cell.value ?? "-",
        }),
        accessor: "ShortName",
    },
    {
        headCellProps: {
            width: getCellWidthInPercent(80),
        },
        accessor: "Active",
        disableSortBy: true,
        getBodyCellProps: (cell) => ({
            shownByRowHover: true,
            actionIcon: "edit",
            actionProps: {
                to: `?action=edit&id=${cell.row.original.RegionId}`,
                replace: true,
                "aria-label": "Edit Region",
            },
        }),
    },
];

const FiltersConfig = [
    {
        name: "active",
        columnAccessor: "RegionId",
        unfilteredValue: "all",
        isSegmentedControl: true,
        options: [
            {
                value: "all",
                label: "All",
            },
            {
                value: "active",
                label: "Active",
            },
            {
                value: "inactive",
                label: "Inactive",
            },
        ],
    },
];

const tableCTAProps = {
    leadingIcon: "expand",
    label: "Add Region",
    to: "?action=add",
    replace: true,
};

const getRowProps = (row) => ({
    style: {
        background: row.values.Active === false ? COLOR_VALUES.Gray_9 : "",
    },
});

const RegionsTable = () => {
    const { regions } = useRegions();

    const [filters, setFilters] = useState();

    if (regions.isLoading) {
        return <>Loading...</>;
    }

    if (regions.isError) {
        return <>Error</>;
    }

    return (
        <VStack>
            <HStack align="end" justify="space-between">
                <TableFilters
                    filtersConfig={FiltersConfig}
                    onChange={setFilters}
                />
                <SecondaryButton {...tableCTAProps} />
            </HStack>
            <Table
                columns={columns}
                data={regions.data}
                filters={filters}
                emptyActionProps={tableCTAProps}
                getRowProps={getRowProps}
            />
        </VStack>
    );
};

export default React.memo(RegionsTable);
